var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { namespace } from "vuex-class";
import { CaseRepaymentService } from "~/services/domain-service/case-repayment.service";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import { MENU_CHANNEL } from "~/config/enum.config";
import { FileUploadService } from "~/services/file-service/file-upload.service";
var CollectionExecutionModule = namespace("collection-execution");
var RepayRecords = /** @class */ (function (_super) {
    __extends(RepayRecords, _super);
    function RepayRecords() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = {
            modify: false,
        };
        _this.fileLists = [];
        _this.srcList = [];
        _this.searchModel = {
            entryTime: [],
            repayAmount: { min: "", max: "" },
            repaymentAcctname: '',
            repaymentAcctno: '',
            collectorRealName: '',
            deptName: '',
        };
        _this.dataSet = [];
        return _this;
    }
    //获取还款记录
    RepayRecords.prototype.refreshData = function () {
        var _this = this;
        if (this.menuChannel === MENU_CHANNEL.Outsource) {
            this.searchModel.name = this.otherData;
        }
        this.searchModel.caseNumber = this.caseNo;
        this.caseRepaymentService
            .selectCaseRepayment(this.searchModel, this.pageService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    RepayRecords.prototype.activated = function () {
        this.refreshData();
    };
    RepayRecords.prototype.onClickDetail = function (row) {
        var _this = this;
        // 根据image_url获取附件详细信息
        this.dialog.modify = true;
        this.fileUploadService.getAllUploadFileByIds(row.imageUrl).subscribe(function (data) {
            var fileList = data;
            _this.fileLists = fileList.map(function (item) {
                return __assign(__assign({}, item), { operatorRealName: row.collectorRealName });
            });
            _this.srcList = fileList.map(function (item) {
                return item.url;
            });
        });
    };
    __decorate([
        Dependencies(PageService)
    ], RepayRecords.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], RepayRecords.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseRepaymentService)
    ], RepayRecords.prototype, "caseRepaymentService", void 0);
    __decorate([
        Dependencies(FileUploadService)
    ], RepayRecords.prototype, "fileUploadService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], RepayRecords.prototype, "otherData", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], RepayRecords.prototype, "menuChannel", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], RepayRecords.prototype, "caseNo", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], RepayRecords.prototype, "caseId", void 0);
    RepayRecords = __decorate([
        Component({
            components: {
                NumberRange: NumberRange
            }
        })
    ], RepayRecords);
    return RepayRecords;
}(Vue));
export default RepayRecords;
